import React from 'react';
import { View, StyleSheet, ViewStyle, TouchableOpacity } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

interface CarouselDotsProps {
  count: number;
  activeIndex: number;
  activeColor?: string;
  inactiveColor?: string;
  containerStyle?: ViewStyle;
  dotsWrapperStyle?: ViewStyle;
  onDotPress?: (index: number) => void;
  showBackground?: boolean;
}

export const CarouselDots: React.FC<CarouselDotsProps> = ({
  count,
  activeIndex,
  activeColor = MARKETPLACE_COLORS.dotActive,
  inactiveColor = MARKETPLACE_COLORS.dotInactive,
  containerStyle,
  dotsWrapperStyle,
  onDotPress,
  showBackground = true,
}) => {
  if (count <= 1) return null;

  const renderDot = (index: number) => {
    const dotElement = (
      <View
        style={[
          styles.dot,
          { backgroundColor: index === activeIndex ? activeColor : inactiveColor },
        ]}
      />
    );

    if (onDotPress) {
      return (
        <TouchableOpacity
          key={index}
          onPress={() => onDotPress(index)}
          activeOpacity={0.7}
          hitSlop={{ top: 8, bottom: 8, left: 4, right: 4 }}
        >
          {dotElement}
        </TouchableOpacity>
      );
    }

    return <View key={index}>{dotElement}</View>;
  };

  return (
    <View style={[styles.container, containerStyle]}>
      <View style={[
        styles.dotsWrapper, 
        !showBackground && styles.dotsWrapperNoBg,
        dotsWrapperStyle,
      ]}>
        {Array.from({ length: count }).map((_, index) => renderDot(index))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  dotsWrapper: {
    flexDirection: 'row',
    gap: 6,
    backgroundColor: MARKETPLACE_COLORS.carouselBg,
    paddingHorizontal: 8,
    paddingVertical: 8,
    borderRadius: 20,
  },
  dotsWrapperNoBg: {
    backgroundColor: 'transparent',
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 3.5,
  },
});

